import NetworkState from 'communication/NetworkState';

export type DisconnectedReason =
    | 'Logging In'
    | 'Login Failed'
    | 'Logged Out'
    | 'Websocket Connection Closed';

export interface ConnectivityStatus {
    connected: boolean;
    timestamp: Date;
    disconnectedReason?: DisconnectedReason;
    lostConnectionStatus?: NetworkState;
}

export interface AvailabilityStatusUpdate {
    timestamp: number;
    status: string;
    available: boolean;
}

export interface ConnectivityState {
    availabilityStatus: Array<AvailabilityStatusUpdate>;
    current: ConnectivityStatus;
    history: ConnectivityStatus[];
}

export const initialConnectivityState: ConnectivityState = {
    availabilityStatus: [],
    current: { connected: false, timestamp: new Date() },
    history: [],
};
